module.exports = __webpack_public_path__ + "img/payment-failed-icon.4bc63f88.svg";